import { render } from "./SectionHeader.vue?vue&type=template&id=0f0d4376&scoped=true&ts=true"
import script from "./SectionHeader.vue?vue&type=script&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&lang=ts"

import "./SectionHeader.vue?vue&type=style&index=0&id=0f0d4376&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0d4376"]])

export default __exports__